import { get } from 'lodash';

export class DataConversionUtil {
	/**
	 * convertArrayToObjectMapping is used to convert any array type value into object form 
	 * (Useful for pas Api data points where some datapoints have got modified into array form wrt current object form eg. esgMetrics)
	 *
	 * @param {array} Array<any>
	 * @returns { [key: string]: any }
	 */
	public static convertArrayToObjectMapping(response: Object, idKey: string = 'name', path: string = ''): { [key: string]: any } {
		const objectMapping = {};
		const array = get(response, path);
		if (array?.length) {
			array.forEach(item => {
				if (!!item[idKey]) {
					objectMapping[item[idKey]] = item;
				}
			});
			array[path] = objectMapping;
		}
		return objectMapping;
	}

}
